import {
  baseAPIRequestMap,
  httpRequestMethods,
  authAPIRequest
} from '@/cllib/axios_init'

import * as url from './url'

export function getGasData () {
  return baseAPIRequestMap('/station1/sales', httpRequestMethods.GET)
}

export function getGasDataYw () {
  return baseAPIRequestMap('/station1', httpRequestMethods.GET)
}

export function getGasDataFgs () {
  return baseAPIRequestMap('/station1/new', httpRequestMethods.GET)
}

export function getAreas () {
  return baseAPIRequestMap('/station1/areaTree', httpRequestMethods.GET)
}

export function addGas (parm) {
  return baseAPIRequestMap('/station1', httpRequestMethods.POST, parm)
}

export function updateGas (id, parm) {
  return baseAPIRequestMap('/station1/' + id, httpRequestMethods.PUT, parm)
}

export function delGas (id) {
  return baseAPIRequestMap('/station1/' + id, httpRequestMethods.DELETE)
}

export function getDistricts (area) {
  return baseAPIRequestMap('/station1/areas/' + area + '/districts', httpRequestMethods.GET)
}

export function getGasType (area) {
  return baseAPIRequestMap('/station1/types', httpRequestMethods.GET)
}

export function mapGetDepot () {
  return mapGetDepotByStatus(1)
}

export function mapGetDepotByStatus (status = 1) {
  return baseAPIRequestMap(url.map.getDepot1ByStatus + `/${status}`, httpRequestMethods.GET)
}

export function getByCompany (company) {
  return baseAPIRequestMap(`/station1/getByCompany/${company}`, httpRequestMethods.GET)
}

export function setPreferential (id, type, details) {
  return baseAPIRequestMap(`/station1/setPreferential/${id}`, httpRequestMethods.PUT, {
    preferential_type: type, preferential_details: details
  })
}

export function getGasDataFromEloop () {
  return authAPIRequest('/gas/detail/list', httpRequestMethods.GET, {
    noPage: 1
  })
}

export function getGasSaleFromEloop (saleDate) {
  return authAPIRequest('/gas/sale/day', httpRequestMethods.GET, {
    noPage: 1,
    saleDate
  })
}

export function companySaleData () {
  return authAPIRequest('/cnpc/gas/daily/route/company', httpRequestMethods.GET)
}

export function getCompanyOut () {
  return authAPIRequest('/cnpc/gas/company/out', httpRequestMethods.GET)
}

export function getTankInventory () {
  return authAPIRequest('/cnpc/gastank/company/current/inventory', httpRequestMethods.GET)
}



// WEBPACK FOOTER //
// ./src/api/mapApi.js